import { render, staticRenderFns } from "./WatermarkOverlay.vue?vue&type=template&id=ce3710f0&scoped=true"
import script from "./WatermarkOverlay.vue?vue&type=script&lang=js"
export * from "./WatermarkOverlay.vue?vue&type=script&lang=js"
import style0 from "./WatermarkOverlay.vue?vue&type=style&index=0&id=ce3710f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3710f0",
  null
  
)

export default component.exports